import { __extends, __assign } from 'tslib';
import React__default from 'react';
import 'react-dates/initialize';
import moment from 'moment-timezone';
import { IconX } from '@tabler/icons';
import { Button } from '../Button/Button.component.js';
import { Sidebar } from '../Sidebar/Sidebar.component.js';
import SidebarHeader from '../SidebarHeader/SidebarHeader.component.js';
import SidebarFooter from '../SidebarFooter/SidebarFooter.component.js';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import colors from '../../util/colors.js';
import DateRangeFilterInline from '../DateRangeFilterInline/DateRangeFilterInline.component.js';
import { propTypes, defaultProps } from './DateRangeFilterSidebar.types.js';
import styles from './DateRangeFilterSidebar.module.scss.js';

var TODAY = 'today';
var THIS_WEEK = 'thisWeek';
var LAST_WEEK = 'lastWeek';
var THIS_MONTH = 'thisMonth';
var LAST_MONTH = 'lastMonth';
var CUSTOM = 'custom';
var DateRangeFilterSidebar = /** @class */ (function (_super) {
    __extends(DateRangeFilterSidebar, _super);
    function DateRangeFilterSidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.closeSidebar = function () {
            _this.props.onClose();
        };
        _this.getStateFromNewSelectedRange = function (newSelectedRange) {
            var timeZone = _this.props.timeZone;
            var startDate = null;
            var endDate = null;
            var selectedRange = CUSTOM;
            var focusedInput = 'startDate';
            var momentStart = moment().tz(timeZone);
            var momentEnd = moment().tz(timeZone);
            switch (newSelectedRange) {
                case TODAY:
                    startDate = momentStart.startOf('day');
                    endDate = momentEnd.endOf('day');
                    selectedRange = TODAY;
                    focusedInput = null;
                    break;
                case THIS_WEEK:
                    startDate = momentStart.startOf('week');
                    endDate = momentEnd.endOf('week');
                    selectedRange = THIS_WEEK;
                    focusedInput = null;
                    break;
                case LAST_WEEK:
                    startDate = momentStart.subtract(1, 'week').startOf('week');
                    endDate = momentEnd.subtract(1, 'week').endOf('week');
                    selectedRange = LAST_WEEK;
                    focusedInput = null;
                    break;
                case THIS_MONTH:
                    startDate = momentStart.startOf('month');
                    endDate = momentEnd.endOf('month');
                    selectedRange = THIS_MONTH;
                    focusedInput = null;
                    break;
                case LAST_MONTH:
                    startDate = momentStart.subtract(1, 'month').startOf('month');
                    endDate = momentEnd.subtract(1, 'month').endOf('month');
                    selectedRange = LAST_MONTH;
                    focusedInput = null;
                    break;
                case CUSTOM:
                    startDate = momentStart.startOf('day');
                    endDate = momentEnd.endOf('day');
                    selectedRange = CUSTOM;
                    focusedInput = 'startDate';
                    break;
                default:
                    startDate = momentStart.startOf('day');
                    endDate = momentEnd.endOf('day');
                    selectedRange = TODAY;
                    focusedInput = null;
                    break;
            }
            return {
                startDate: startDate,
                endDate: endDate,
                selectedRange: selectedRange,
                focusedInput: focusedInput,
            };
        };
        _this.getData = function (insideState) {
            _this.setState(insideState);
        };
        _this.handleApplyFilters = function () {
            _this.props.onDatesChange({
                startDate: _this.state.startDate || null,
                endDate: _this.state.endDate || null,
                selectedRange: _this.state.selectedRange,
                customSelectedRange: _this.state.selectedCustomRange,
            });
            _this.props.onClose();
        };
        _this.isCustomDatePickerRender = function () {
            var _a;
            return (!!_this.props.customDateRanges &&
                !_this.props.customDateRanges.length) ||
                ((_this.state.selectedRange === CUSTOM ||
                    ((_a = _this.state.selectedCustomRange) === null || _a === void 0 ? void 0 : _a.name) === CUSTOM) &&
                    _this.props.isCustomRangeShowed);
        };
        _this.datesChanged = function (_a) {
            var startDate = _a.startDate, endDate = _a.endDate, selectedRange = _a.selectedRange, customSelectedRange = _a.customSelectedRange;
            if (selectedRange === CUSTOM)
                return;
            _this.props.onDatesChange({
                startDate: startDate,
                endDate: endDate,
                selectedRange: selectedRange,
                customSelectedRange: customSelectedRange,
            });
            _this.setState({
                selectedRange: selectedRange || 'today',
                startDate: moment(startDate),
                endDate: moment(endDate),
            });
            _this.props.onClose();
        };
        var _a = _this.props, selectedRange = _a.selectedRange, customSelectedRange = _a.customSelectedRange;
        var _b = _this.props, startDate = _b.startDate, endDate = _b.endDate, customDateRanges = _b.customDateRanges, timeZone = _b.timeZone;
        var focusedInput = 'startDate';
        var stateStartDate = startDate && moment(startDate);
        var stateEndDate = endDate && moment(endDate);
        if (!startDate || !endDate) {
            if (customDateRanges && customDateRanges.length > 0) {
                customSelectedRange = __assign({}, customDateRanges[0]);
                stateStartDate = moment(customDateRanges[0].startDate);
                stateEndDate = moment(customDateRanges[0].endDate);
            }
            else if (selectedRange && !customDateRanges) {
                var newState = _this.getStateFromNewSelectedRange(selectedRange);
                stateStartDate = newState.startDate;
                stateEndDate = newState.endDate;
                selectedRange = newState.selectedRange;
                focusedInput = newState.focusedInput;
            }
            else {
                stateStartDate = moment().tz(timeZone).startOf('day');
                stateEndDate = moment().tz(timeZone).endOf('day');
                selectedRange = TODAY;
                focusedInput = 'startDate';
            }
        }
        _this.state = {
            focusedInput: focusedInput,
            selectedCustomRange: customDateRanges ? customSelectedRange : null,
            selectedRange: customDateRanges ? null : selectedRange || CUSTOM,
            startDateInputInvalid: false,
            endDateInputInvalid: false,
            startDate: stateStartDate,
            endDate: stateEndDate,
        };
        return _this;
    }
    DateRangeFilterSidebar.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b, _c, _d, _e, _f;
        var newState = {};
        if (this.props.startDate !== prevProps.startDate) {
            var startDate = this.props.startDate
                ? moment(this.props.startDate)
                : null;
            newState['startDate'] = startDate;
        }
        if (this.props.endDate !== prevProps.endDate) {
            var endDate = this.props.endDate
                ? moment(this.props.endDate)
                : null;
            newState['endDate'] = endDate;
        }
        if (((_a = this.props.customSelectedRange) === null || _a === void 0 ? void 0 : _a.name) !==
            ((_b = prevProps.customSelectedRange) === null || _b === void 0 ? void 0 : _b.name) ||
            ((_c = this.props.customSelectedRange) === null || _c === void 0 ? void 0 : _c.startDate) !==
                ((_d = prevProps.customSelectedRange) === null || _d === void 0 ? void 0 : _d.startDate) ||
            ((_e = this.props.customSelectedRange) === null || _e === void 0 ? void 0 : _e.endDate) !==
                ((_f = prevProps.customSelectedRange) === null || _f === void 0 ? void 0 : _f.endDate)) {
            newState['selectedCustomRange'] = this.props.customSelectedRange;
        }
        if (this.props.selectedRange !== prevProps.selectedRange) {
            newState['selectedRange'] = this.props.selectedRange;
        }
        if (Object.keys(newState).length > 0) {
            this.setState(newState);
        }
    };
    DateRangeFilterSidebar.prototype.render = function () {
        var _a = this.state, startDateInputInvalid = _a.startDateInputInvalid, endDateInputInvalid = _a.endDateInputInvalid, startDate = _a.startDate, endDate = _a.endDate;
        var _b = this.props, sidebarHeader = _b.sidebarHeader, sidebarProps = _b.sidebarProps, sidebarZIndex = _b.sidebarZIndex, isDayBlocked = _b.isDayBlocked, isOpen = _b.isOpen, dateLabels = _b.dateLabels, rangeLabels = _b.rangeLabels, applyFiltersText = _b.applyFiltersText, startDateInputRef = _b.startDateInputRef, endDateInputRef = _b.endDateInputRef, invalidInputErrorMessage = _b.invalidInputErrorMessage, calendarProps = _b.calendarProps, customDateRanges = _b.customDateRanges, isCustomRangeShowed = _b.isCustomRangeShowed, selectedRange = _b.selectedRange, customSelectedRange = _b.customSelectedRange, timeZone = _b.timeZone, dateFormat = _b.dateFormat, inputDateFormats = _b.inputDateFormats, calendarLocale = _b.calendarLocale;
        var closeButton = (React__default.createElement(ButtonBase, { onClick: this.closeSidebar, type: "button", tabIndex: -1, "data-testid": 'close-button', className: styles.DateRangeFilterSidebar_closeButton, title: "Close" },
            React__default.createElement(IconX, { color: colors.black, size: 20 })));
        /* <IconButton
            color={colors.black}
            disableBorder
            className={styles.DateRangeFilterSidebar_closeButton}
            name="CloseIcon"
            alt="Close"
            onClick={this.closeSidebar}
        /> */
        var disableApplyFilterBtn = startDateInputInvalid ||
            endDateInputInvalid ||
            !startDate ||
            !endDate;
        return (React__default.createElement(Sidebar, __assign({}, sidebarProps, { className: styles.DateRangeFilterSidebar, zIndex: sidebarZIndex, isOpen: isOpen, headerComponent: React__default.createElement(SidebarHeader, { centerElement: React__default.createElement("div", { className: styles.DateRangeFilterSidebar_header }, sidebarHeader), leftElement: closeButton }), footerComponent: this.isCustomDatePickerRender() ? (React__default.createElement(SidebarFooter, null,
                React__default.createElement(Button, { "data-testid": 'apply-filters-button', onClick: this.handleApplyFilters, variant: "secondary", disabled: disableApplyFilterBtn, block: true, type: "button" }, applyFiltersText))) : undefined }),
            React__default.createElement(DateRangeFilterInline, { startDateInputRef: startDateInputRef, endDateInputRef: endDateInputRef, selectedRange: selectedRange, onDatesChange: this.datesChanged, dateLabels: dateLabels, rangeLabels: rangeLabels, invalidInputErrorMessage: invalidInputErrorMessage, customDateRanges: customDateRanges, isCustomRangeShowed: isCustomRangeShowed, startDate: startDate, endDate: endDate, customSelectedRange: customSelectedRange, timeZone: timeZone, dateFormat: dateFormat, isDayBlocked: isDayBlocked, calendarProps: calendarProps, className: styles.FlexColumn, getData: this.getData, inputDateFormats: inputDateFormats, calendarLocale: calendarLocale })));
    };
    DateRangeFilterSidebar.displayName = 'DateRangeFilterSidebar';
    DateRangeFilterSidebar.propTypes = propTypes;
    DateRangeFilterSidebar.defaultProps = __assign({}, defaultProps);
    return DateRangeFilterSidebar;
}(React__default.Component));

export { DateRangeFilterSidebar as default };
